import { useState } from 'react'

import { cn } from '@/lib/utils'
import { useTranslation } from '@/i18n'

type Status = 'idle' | 'loading' | 'success' | 'error'

export function Newsletter({ className }: { className?: string }) {
    const { t, locale } = useTranslation()
    const [email, setEmail] = useState('')
    const [status, setStatus] = useState<Status>('idle')

    async function handleSubmit(event: React.FormEvent) {
        event.preventDefault()
        setStatus('loading')

        try {
            const response = await fetch('/api/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, locale })
            })

            if (response.ok) {
                setStatus('success')
                setEmail('')
            } else {
                setStatus('error')
            }
        } catch {
            setStatus('error')
        }
    }

    return (
        <form className={cn('newsletter-form', className)} onSubmit={handleSubmit} noValidate>
            <div className='newsletter-row'>
                <input
                    type='email'
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder={t.footer.emailPlaceholder}
                    aria-label={t.footer.emailPlaceholder}
                    className='newsletter-input'
                />
                <button type='submit' className='newsletter-button' disabled={status === 'loading'}>
                    {t.footer.subscribe}
                </button>
            </div>
            {status === 'success' && <p className='newsletter-message is-success'>{t.footer.subscribeSuccess}</p>}
            {status === 'error' && <p className='newsletter-message is-error'>{t.footer.subscribeError}</p>}
        </form>
    )
}
